"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitialDomain = createInitialDomain;
const MessageOutbox_1 = require("./message/MessageOutbox");
const EditOutbox_1 = require("./message/EditOutbox");
const UnknownAuthenticationDomain_1 = require("./UnknownAuthenticationDomain");
function createInitialDomain(adapterFactory, config, internetStatusListener, organizationIdStorage, deviceTokenProvider, outboxStore) {
    MessageOutbox_1.MessageOutbox.configure(outboxStore);
    EditOutbox_1.EditOutbox.configure(outboxStore);
    return new UnknownAuthenticationDomain_1.UnknownAuthenticationDomain(adapterFactory, config, internetStatusListener, organizationIdStorage, deviceTokenProvider);
}
